import * as React from "react"
import { Dialog, AppBar, ButtonBase, Toolbar, Slide, TextField } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions'
import { useSelector } from "react-redux"
import * as AppTypes from "AppTypes"

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            position: 'relative',
        },
        title: {
            marginLeft: theme.spacing(2),
            flex: 1,
        },
    }),
);

const Transition = React.forwardRef(function Transition(props: TransitionProps & {children?: React.ReactElement<any, any>}, ref: React.Ref<unknown>) {
    return <Slide {...props} direction="up" ref={ref}/>
})

interface ITextDialogProps {
    title: string
    description: string
    maxLength: number
    contentSource: string
    onClose: () => void
    onSave: (value: string) => void
    open: boolean
    placeholderText: string
}

const TextDialog: React.FC<ITextDialogProps> = props => {
    const { title, description, maxLength, contentSource, onClose, onSave, open, placeholderText } = props

    const [value, updateValue] = React.useState(contentSource)
    const [length, updateLength] = React.useState(contentSource ? contentSource.length : 0)

    const classes = useStyles();

    const handleKeyPress = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateValue(event.target.value)
        updateLength(event.target.value.length)
    }

    const { langPack } = useSelector((store: AppTypes.ReducerState) => ({
        langPack: store.config.langPack
    }))

    React.useEffect(() => {
        const body: HTMLBodyElement = document.querySelector("body")
        if (open) {
            updateValue(contentSource ? contentSource : "")
            updateLength(contentSource ? contentSource.length : 0)
            body.setAttribute("data-lock", "true")
        } else {
            body.removeAttribute("data-lock")
        }
    }, [open, contentSource])

    const onSaveHandler = () => {
        if (length <= maxLength) {
            onSave(value)
        }
    }

    return (
        <Dialog
            container={document.querySelector("#dialogContainer")}
            fullScreen
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            className={`dialog ${(length > maxLength) ? `error` : ``}`}>
            <AppBar className={classes.appBar}>
                <Toolbar className="btn-wrapper">
                    <ButtonBase
                        className="btn-close"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <img src="images/x.svg" alt="" style={{ width: "20px", height: "20px" }} />
                    </ButtonBase>
                    <ButtonBase
                        disabled={length > maxLength}
                        className="btn-save"
                        style={{ textTransform: "capitalize" }}
                        onClick={onSaveHandler}
                    >
                        {langPack["buttonSave"]}
                    </ButtonBase>
                </Toolbar>
                <div className="text-wrapper">
                    <div className="header">{title}</div>
                    <div className="description">{description}</div>
                </div>
            </AppBar>
            <div className="dialog-textarea-background">
                <TextField
                    value={value}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleKeyPress(event)}
                    multiline
                    placeholder={placeholderText}
                />
            </div>
            <div className="dialog-footer">({length} / {maxLength} {langPack["labelChars"]})</div>
        </Dialog>
    )
}

export default TextDialog